import {  TableCell, TableBody, TableRow  } from "@mui/material";
import { TableHeader } from 'edocatbase/Table';

export interface TableBodyProps {
  tableHeaders: TableHeader[];
  data: [
    {
      [key: string]: any;
    }
  ];
  noDataText: string;
}

export default class EdocatTableBody extends React.PureComponent<TableBodyProps> {
  render() {
    const { data, tableHeaders, noDataText } = this.props;
    return (
      <TableBody>
        {data.length === 0 && (
          <TableRow>
            <TableCell align="center" colSpan={tableHeaders.length}>
              {noDataText || window.Alfresco.messages.global['edocat.text.no-results']}
            </TableCell>
          </TableRow>
        )}
        {data.length > 0 &&
          data.map((row, index) => (
            <TableRow key={`row${index}`}>
              {tableHeaders.map((it, index) => {
                const value = it.renderPropName ? row[it.renderPropName] : row[it.id];
                return (
                    <TableCell key={index}>{value?.title ?? value}</TableCell>
                )})}
            </TableRow>
          ))}
      </TableBody>
    );
  }
}
